import {HttpErrorResponse} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

import {filter} from 'rxjs/operators';

import {MessageService} from '../message/message.service';
import {User} from './user';
import {UserService} from './user.service';

@Component({
  selector: 'aqx-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})

export class UserComponent implements OnInit {
  signInUrl: string;
  user: User;
  isUserEntitledApiStore: boolean;

  constructor(
    private messageService: MessageService,
    private router: Router,
    private userService: UserService) {
  }

  ngOnInit() {
    this.assignUser();
    this.assignSignInUrlOnNavigationEvent();
  }

  assignUser(): void {
    this.userService.userObservable
      .subscribe(user => {
        this.user = user;
        this.isUserEntitledApiStore = this.userService.isUserEntitledApiStore();
      });
  }

  assignSignInUrlOnNavigationEvent() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.signInUrl = this.userService.getSignInUrl(event.url);
      });
  }

  signOut($event): void {
    $event.preventDefault();
    this.userService.signOut()
      .then(() => {
        this.reload();
      })
      .catch((httpErrorResponse: HttpErrorResponse) => {
        if (httpErrorResponse.status === 401) {
          this.userService.handleHttpError401();
          this.reload();
        } else {
          this.messageService.error(`Error signing out. ${httpErrorResponse.statusText}.`);
        }
      });
  }

  private reload() {
    // this.router.navigate([this.currentNavigationUrl]);
    location.reload(); // seems heavy handed and not "angular" like, but could not get, e. g., API detail page to refresh after sign out
  }
}
